import type { DocumentsItemDto } from "@/api/types";
import { File06Icon } from "@/components/Icons/File06Icon";
import { FolderIcon } from "@/components/Icons/FolderIcon";
import { Image01Icon } from "@/components/Icons/Image01Icon";
import { Link03Icon } from "@/components/Icons/Link03Icon";

export function DocumentsFileIcon({ type }: { type: DocumentsItemDto["type"] }): React.ReactNode {
  switch (type) {
    case "folder":
      return <FolderIcon tone="warning" />;
    case "document":
      return <File06Icon tone="secondary" />;
    case "image":
      return <Image01Icon tone="secondary" />;
    case "link":
      return <Link03Icon tone="secondary" />;
    default:
      console.warn(`File type ${type} unknown`);

      return <File06Icon tone="secondary" />;
  }
}
